/*eslint-disable*/
import {
    memo,
    useState,
    useEffect,
    useCallback,
    useRef,
} from 'react';
import { getCurrentTimeZoneDate } from 'helpers';

const CancelationTimer = ({
    amountClaimed, allocationTime, state, hasAccess, isCustom, cancelation
}) => {
    const day = 60 * 60 * 24;
    const [timer, setTimer] = useState('-----');
    const timerRef = useRef(null);

    const hasCancelAccess = useCallback(() => {
        if (Number(amountClaimed) || !hasAccess || (isCustom && cancelation) || (new Date() - new Date(getCurrentTimeZoneDate(allocationTime))) / 1000 > day || state === 'Canceled') {
            clearInterval(timerRef.current);
            return setTimer('-----');
        }

        let seconds = day - (new Date() - new Date(getCurrentTimeZoneDate(allocationTime))) / 1000;
        const hours = String(parseInt(seconds / 3600)).padStart(2, '0');
        seconds %= 3600;
        const minutes = String(parseInt(seconds / 60)).padStart(2, '0');
        seconds = String(Math.floor(seconds % 60)).padStart(2, '0');
        setTimer(`${hours}:${minutes}:${seconds}`);
    }, [amountClaimed, allocationTime, state, hasAccess, isCustom]);

    const hasCancelAccessTimer = useCallback(() => {
        clearInterval(timerRef.current);
        timerRef.current = setInterval(hasCancelAccess, 1000);
    }, [hasCancelAccess]);

    useEffect(() => {
        hasCancelAccess();
        hasCancelAccessTimer();

        return () => {
            clearInterval(timerRef.current);
        };
    }, [hasCancelAccessTimer]);

    return (
        <span>{timer}</span>
    );
};

export default memo(CancelationTimer);
